
export const sFechaPublicacion = '2025-12-16T13:46:06.8759348-06:00';
export const sVersion = 'vf1.1.512161346';
            